// Handlers de formatação de campos (CEP, telefone) reutilizáveis entre
// componentes, para manter a máscara consistente em toda a aplicação.

import { useCallback } from 'react';
import { formatCEP, formatPhone } from '../utils/formatters';

export const useFieldFormatters = (onChange) => {
  const handleCEPChange = useCallback((e) => {
    const { name, value } = e.target;

    const formatted = formatCEP(value);

    // Evento sintético mantém a mesma interface do onChange original
    onChange({
      target: {
        name,
        value: formatted
      }
    });
  }, [onChange]);

  const handlePhoneChange = useCallback((e) => {
    const { name, value } = e.target;

    const formatted = formatPhone(value);

    onChange({
      target: {
        name,
        value: formatted
      }
    });
  }, [onChange]);

  return {
    handleCEPChange,
    handlePhoneChange
  };
};
